import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { selectLMSChaptersQueryItems } from '../../../../../redux/lms/collections/chapters/selector';
import { lmsChapters } from '../../../../../redux/lms/collections/chapters/action';
import PageLoader from '../../../../../components/PageLoader';
import ChapterComponent from '../components/chapter.component';


const ManagementLMSChapter = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const parmas: any = useParams();
  const lmsChaptersQuery = useSelector(selectLMSChaptersQueryItems);
  const [isQuery, setIsQuery] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [selectLMSChapters, setSelectLMSChapters] = useState<any>({
    "title": "",
    "description": "",
    "mappedTopics": {
      "mappedTopicIds": []
    },
    "mediaMappings": {
      "mediaFiles": [],
      "templates": []
    }
  });

  const fetchLMSChaptersQueryById = () => {
    dispatch(lmsChapters.query({
      url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/chapters/query`,
      entity: 'lmsChapters',
      jsonData: {
        records: [
          {
            id: parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true);
    });
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectLMSChapters({ ...selectLMSChapters, [field]: event });
  }

  useEffect(() => {
    if (parmas?.id > 0) {
      fetchLMSChaptersQueryById();
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (isQuery) {
      setSelectLMSChapters(lmsChaptersQuery?.result?.items);
    }
  }, [isQuery]);

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(lmsChapters.resetAction({ actionType: 'update' }))
      await dispatch(lmsChapters.update({
        url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/chapters`,
        entity: 'lmsChapters',
        jsonData: {
          records: [
            selectLMSChapters
          ]
        }
      })).then(() => {
        back();
      });
    } else {
      await dispatch(lmsChapters.resetAction({ actionType: 'create' }))
      await dispatch(lmsChapters.create({
        url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/chapters`,
        entity: 'lmsChapters',
        jsonData: {
          records: [
            selectLMSChapters
          ]
        }
      })).then(() => {
        back();
      });
    }
  }

  const back = () => {
    navigate('/management/e-applications/lms/chapters');
  }

  return (
    <>
      {lmsChaptersQuery?.isLoading ? <PageLoader /> :
        <ChapterComponent
          handleInnerFormChange={handleInnerFormChange}
          selectLMSChapters={selectLMSChapters}
          back={back}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  );
}

export default ManagementLMSChapter;
